"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_photos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "photos-hi"), /*#__PURE__*/React.createElement("g", {
    id: "e395d798-670b-4e17-8c8b-2959baa84810",
    "data-name": "photos-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b279892a-b4c1-40d4-9e3d-fd8331d737bd",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "78db6ddb-31d7-48b8-ab9e-3f833b391487",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f25ee2fb-ed8b-40e6-9aa9-6954a1332258",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6f84e321-ec3d-4272-a35a-36202f192b26",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eb97cb15-ec53-4ad6-9eaa-250b7f57c2b5",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1fecab31-c581-47e2-821f-c34db8f059ec",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4cf4de8f-f942-4a8e-b5aa-7bd64c634f8e",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1b40dba8-706d-42d3-a19f-88f37b96b0e0",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fe7de56f-96ed-41c4-88ee-e8a89597fcd0",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "acf77aab-6711-4aa5-b189-de1ab2e5ca3e",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8a85cad6-3814-4202-9d16-23c74b03667d",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c566c74a-6ff5-4fc8-a2e5-c198044f782b",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "91157496-c64f-4e54-8eff-3ca8a756b17b",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "2a99a774-a492-4254-a477-3f2689e3a564",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(192 0) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.41,118.35l12.23-12.23a8,8,0,0,1,11.31,0l35,35V40a16,16,0,0,0-16-16H40A16,16,0,0,0,24,40v89.57l42.21-43a8,8,0,0,1,11.37-.05Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.64,106.13l-12.23,12.23L77.57,86.51a8,8,0,0,0-11.37.05L24,129.57V152a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16V141.18l-35-35A8,8,0,0,0,121.64,106.13Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 56,
    r: 12.5,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,66.5A12.49,12.49,0,0,1,123.55,55c0,.33-.05.66-.05,1a12.5,12.5,0,0,0,25,0c0-.34,0-.67-.05-1A12.49,12.49,0,0,1,136,66.5Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.9,166.86A16,16,0,0,0,168,152V141.18l-35-35a8,8,0,0,0-11.31,0l-12.23,12.23Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,86.58l-42.2,43V152a16,16,0,0,0,16,16H152a15.93,15.93,0,0,0,5.9-1.14L77.56,86.52A8,8,0,0,0,66.2,86.58Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }))))))))))))))));
}

var _default = ic_photos;
exports.default = _default;